import { PrimeIcons } from "primereact/api";

import { labelUploadeBy, labelLastUpdate } from "_constants";
import { formatDataSource } from "utils";
import { useAppSelector } from "store/store";
import { Source } from "interfaces";

export const SourceDetailPanelHeader = () => {
  const currentSource = useAppSelector(
    (state) => state.gestioneSourcesSlice.currentSource
  ) as Source | null;

  return (
    <div className="flex-container column gap-12">
      <h3>{currentSource?.name}</h3>
      <div className="flex-container align-center gap-8">
        <i className={PrimeIcons.UPLOAD} />
        <span className="text-base-regular">{labelUploadeBy}</span>
        <span className="text-base-regular-semibold capitalize">
          {currentSource?.createdBy}
        </span>
        <span className="text-base-regular">•</span>
        <i className={PrimeIcons.CALENDAR} />
        <span className="text-base-regular">{labelLastUpdate}</span>
        <span className="text-base-regular-semibold capitalize">
          {formatDataSource(currentSource?.lastUpdate ?? "")}
        </span>
      </div>
    </div>
  );
};
